import React from 'react';
import { IIcon } from 'common/interfaces/interface';

export const IconNotificationsCloudValidator: React.FC<IIcon> = ({ active }) => {
  let color = active ? '#3455DD' : '#6D6D7A';

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14 7.5C14 11.0899 11.0899 14 7.5 14C3.91015 14 1 11.0899 1 7.5C1 3.91015 3.91015 1 7.5 1C11.0899 1 14 3.91015 14 7.5ZM6.58631 8.81401H8.4369C8.78363 8.81401 8.99043 9.20043 8.79811 9.48892L7.87281 10.8769C7.70098 11.1346 7.32223 11.1346 7.1504 10.8769L6.2251 9.48892C6.03278 9.20043 6.23958 8.81401 6.58631 8.81401ZM8.34999 6.94575L7.51152 5.5483L6.67305 6.94575H8.34999ZM9.34946 7.94575H5.67358C5.33615 7.94575 5.12773 7.57763 5.30134 7.28829L7.13928 4.22506C7.30789 3.94404 7.71516 3.94404 7.88377 4.22506L9.72171 7.28829C9.89532 7.57763 9.68689 7.94575 9.34946 7.94575ZM13.3536 12.6464C13.1583 12.4512 12.8417 12.4512 12.6464 12.6464C12.4512 12.8417 12.4512 13.1583 12.6464 13.3536L14.1464 14.8536C14.3417 15.0488 14.6583 15.0488 14.8536 14.8536C15.0488 14.6583 15.0488 14.3417 14.8536 14.1464L13.3536 12.6464Z"
        fill={color}
      />
    </svg>
  );
};
